/**
 * Sheets Page (Univer Workspace) — Plan 1966
 *
 * Placeholder component — the actual Univer iframe is rendered by PersistentUniver
 * in MainLayout so it stays mounted across navigation.
 *
 * This component exists only to satisfy the router (so /sheets is a valid route).
 * Mirrors AiPage / BlogDashboardPage / InboxPage.
 */

export function SheetsPage() {
  // PersistentUniver in MainLayout handles the actual iframe rendering
  return null;
}
